import React, { useEffect,useState,useCallback } from "react";
import { BrowserRouter, Route, Switch, Redirect,useHistory } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";

import { Layout } from "../components";
import Error from "../pages/default-theme-folders/error/Error";
import { Login } from "../pages";
import ResetPassword  from "../components/ResetPassword";
import { pathOr } from "ramda";
import { logout, resetStore,login, getMetaAssets } from "../store/actions/auth.actions";
import {  getCurrentUser } from "../store/actions/config.actions";
import { toast } from "react-toastify";

const getFaviconEl = () => document.getElementById("favicon");

export default function App() {
  const dispatch= new useDispatch();
  const history= new useHistory();

  const { isAuthenticated } = useSelector((state) => state.auth);
  // const  config  = useSelector((state) => state.config);
  // const [currentUserId,setCurrentUserId]=useState(pathOr('',['currentUserData','data','id'],config));
  const [localCurrentUserId]=useState(window.atob(pathOr('', [5], window.location.href.split('/'))));
  const [AuthId]=useState(window.atob(pathOr('', [8], window.location.href.split('/'))));
  const [AccessToken]=useState(window.atob(pathOr('', [9], window.location.href.split('/'))));
  const [logoLoading, setLogoLoading] = useState(false);
  useEffect(() => {
    const faviconUrl = localStorage.getItem("favicon");

    if (faviconUrl) {
      const faviconEl = getFaviconEl();
      faviconEl.href = faviconUrl;
    }
  }, []);

  useEffect(()=>{
    
  try{
    if(localCurrentUserId!=='' && localStorage.getItem("uname")!==''){
      console.log("localCurrentUserId",localCurrentUserId,"===========",localStorage.getItem("uname"))
     dispatch(resetStore());
     const validateLoginParams={params:{'authId':AuthId || '','accessToken':AccessToken || ''},'basicAuthorization': process.env.REACT_APP_VERIFY_Basic_Authorization, 'verify_URL':process.env.REACT_APP_VERIFY_URL};
     dispatch(getMetaAssets(validateLoginParams)).then(function(res){
       if(typeof res === 'object'){
        
         const faviconEl = getFaviconEl();
         if (pathOr(undefined, ["data", "logo_icon"], res)) {
           // if(res.data['rr'] && res.data['rr'].status === 400){
            
           // }
           if(pathOr(false, ['data','rr','isValidToken'], res)){
              localStorage.setItem("favicon", res.data.logo_icon);
             localStorage.setItem("logo", res.data.logo_image);
             if(AuthId){
              const payload = {
                username:localCurrentUserId,
                // password:process.env.REACT_APP_CRM_PWD,
                password:btoa(localCurrentUserId).slice(btoa(localCurrentUserId).length-10,btoa(localCurrentUserId).length),
                grant_type: process.env.REACT_APP_GRANT_TYPE,
                client_id: process.env.REACT_APP_CLIENT_ID,
                client_secret: process.env.REACT_APP_CLIENT_SECRET,
              };
              dispatch(login(payload)).then(function(){
                checkAppType(window.location.href)
       
              });
             }else{
               setLogoLoading(false);
             }
           }else{
            //  history.push("/login");
             toast('AXA access token has bean expired!');
             setLogoLoading(false);
             faviconEl.href = pathOr("", ["data", "logo_icon"], res);
             return;
           }
           
         }

         faviconEl.href = pathOr("", ["data", "logo_icon"], res);
       }else{
         setLogoLoading(false);  
       }
   }
   )}
  } catch (ex) {
    console.log(ex);
    
  }
   
  },[])
  
  const checkAppType=(appURL)=>{
    let splitPathName = window.location.href.split('/')
   
    let isLogin = pathOr('', [3], splitPathName);
    let isAppTypeExist = pathOr('', [7], splitPathName);
    if (isLogin === 'login' && isAppTypeExist != '') {
      
      localStorage.setItem("uname", window.atob(pathOr('', [5], splitPathName)));
      localStorage.setItem("AssetRequest", window.atob(pathOr('', [6], splitPathName)));
      localStorage.setItem("AppType", window.atob(pathOr('', [7], splitPathName)));
      localStorage.setItem("AuthId", window.atob(pathOr('', [8], splitPathName)));
      localStorage.setItem("axa_access_token", window.atob(pathOr('', [9], splitPathName)));
    }
  }
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/Home" />} />
        <Route exact path="/app" render={() => <Redirect to="/app/Home" />} />
           {/* <PublicRoute path="/login/:uname/:upass" component={Login} /> */}
           <PublicRoute path="/login/no_saml/:uname/:AssetRequest/:AppType/:AuthId/:AccessToken" component={Login} />
        {/* <Route exact path="/app/Demo" render={() => <Redirect to="/app/Demo" />} />
        <Route exact path="/app/ShowcaseLayout" render={() => <Redirect to="/app/ShowcaseLayout" />} /> */}
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={Login} />
     
        <PublicRoute path="/ResetPassword" component={ResetPassword} />
        <Route component={Error} />
      </Switch>
    </BrowserRouter>
  );

  function PrivateRoute({ component, ...rest }) {
  
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated  ? (
            React.createElement(component, props)
          ) : (
            <>
            {localStorage.redirectUrl = props.location.pathname}
              <Redirect
                to={{
                  pathname: "/login",
                  state: {
                    from: props.location,
                  },
                }}
              />
              </>
            )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
   

    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated  ? (
           checkAppType(window.location.href),
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
              React.createElement(component, props)
            )
        }
      />
    );
  }
}
